import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0502 from "../../../lesson/course-05/lesson-02/lesson";
import lesson0506 from "../../../lesson/course-05/lesson-06/lesson";
import lesson0511 from "../../../lesson/course-05/lesson-11/lesson";
import lesson0514 from "../../../lesson/course-05/lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "1e9c0c2c-0ce3-4ea3-9dc5-8dbb87892915",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0502),
    lesson: lesson0502,
  },
  {
    id: "f9d438ed-132e-4d0f-b682-f28f1d0c9d33",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
  {
    id: "480fce9c-751e-46d4-a243-c0cce7cf891d",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0511),
    lesson: lesson0511,
  },
  {
    id: "0ae87d66-17de-48d9-b56b-917817fa4174",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0514),
    lesson: lesson0514,
  },
];

export default lessonLinks;
